import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  requiredFilter: {
    id: 'app.RehireCheckStage.ReportMappings.requiredFilter',
    defaultMessage: 'Enter the name the report expects',
    description: 'Correct a missing shared filter parameter name',
  },
  missingApplicantField: {
    id: 'app.RehireCheckStage.ReportMappings.missingApplicantField',
    defaultMessage: 'Choose an applicant field',
    description: 'Correct an empty applicant field in a new filter row',
  },
  applicantHeading: {
    id: 'app.RehireCheckStage.ReportMappings.applicantHeading',
    defaultMessage: 'Applicant field',
    description: 'Typed applicant value to send to the report',
  },
  filterHeading: {
    id: 'app.RehireCheckStage.ReportMappings.filterHeading',
    defaultMessage: 'Report filter',
    description: 'Parameter name expected by the report',
  },
  filterHelp: {
    id: 'app.RehireCheckStage.ReportMappings.filterHelp',
    defaultMessage: 'Names from your Workday admin',
    description: 'The Workday administrator supplies the report filter names',
  },
  reportHeading: {
    id: 'app.RehireCheckStage.ReportMappings.reportHeading',
    defaultMessage: 'Report',
    description: 'Report associated with an output column',
  },
  columnHeading: {
    id: 'app.RehireCheckStage.ReportMappings.columnHeading',
    defaultMessage: 'Report column',
    description: 'Returned report column to map',
  },
  search: {
    id: 'app.RehireCheckStage.ReportMappings.search',
    defaultMessage: 'Search the report with',
    description:
      'Applicant values passed as filters to every configured report',
  },
  searchHelp: {
    id: 'app.RehireCheckStage.ReportMappings.searchHelp',
    defaultMessage:
      'We send these values to every report. The report finds the former employee.',
    description:
      'The report controls its own search using the configured filters',
  },
  applicantField: {
    id: 'app.RehireCheckStage.ReportMappings.applicantField',
    defaultMessage: 'Applicant field {number}',
    description:
      'Accessible name for the typed applicant field in a filter row',
  },
  reportFilter: {
    id: 'app.RehireCheckStage.ReportMappings.reportFilter',
    defaultMessage: 'Report filter for {field}',
    description: 'Name of the report parameter receiving this applicant value',
  },
  value: {
    id: 'app.RehireCheckStage.ReportMappings.value',
    defaultMessage: 'value {number}',
    description: 'An unnamed applicant value in a newly added filter row',
  },
  addValue: {
    id: 'app.RehireCheckStage.ReportMappings.addValue',
    defaultMessage: 'Add a value',
    description: 'Add another applicant-to-report filter mapping',
  },
  removeValue: {
    id: 'app.RehireCheckStage.ReportMappings.removeValue',
    defaultMessage: 'Remove {field}',
    description: 'Remove the filter mapping for this applicant field',
  },
  employeeId: {
    id: 'app.RehireCheckStage.ReportMappings.employeeId',
    defaultMessage: 'Employee ID',
    description:
      'Employee number copied separately from the typed identity reference',
  },
  employeeColumn: {
    id: 'app.RehireCheckStage.ReportMappings.employeeColumn',
    defaultMessage: 'Employee ID column in {report}',
    description: 'Returned column carrying this report’s employee number',
  },
  chooseColumn: {
    id: 'app.RehireCheckStage.ReportMappings.chooseColumn',
    defaultMessage: 'Choose a column',
    description: 'Placeholder for an unmapped report output column',
  },
  missingColumn: {
    id: 'app.RehireCheckStage.ReportMappings.missingColumn',
    defaultMessage: 'Choose a returned report column',
    description:
      'Correct a mapping absent from the current allowed returned metadata',
  },
  runFirst: {
    id: 'app.RehireCheckStage.ReportMappings.runFirst',
    defaultMessage: 'Run report first',
    description:
      'Column discovery must finish before an output column can be mapped',
  },
});
